const getRouterWithPrefix = (routerPrefix: string, initialRouter: string): string => {
  return routerPrefix ? `/${routerPrefix}/${initialRouter}` : `/${initialRouter}`;
};

export default getRouterWithPrefix;
